import { useOpenEditIntegrationTokenModal } from '../../../../../utils/routes/modals/modalsActions'

export const onInstallService = (config, openModal) => {
  openModal('integrations/segware', config, 'Nova integração')

  return
}

export const useReinstallService = (config, openModal) => {
  const openTokenModal = useOpenEditIntegrationTokenModal()

  return ({ id }) => {
    openTokenModal({ service: config.key, integrationId: id })
  }
}
